import { StdResponse, request } from "@/global/config/request";
import { MonitorParameter, MonitorParameterExt } from "@/global/interface/monitor-object/monitor-parameter";

/**
 * 新增监测参数
 * 
 * @param projectId 项目id
 * @param data      监测对象数据
 */
export function addMonitorParameter(projectId: number, monitorObjectId: number, data: MonitorParameter, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/monitor-objects/${monitorObjectId}/monitor-parameters`, data, {
        params: {
            ...params,
        }
    })
}

/**
  * 获得根监测参数列表，含直接参数
  * 
  * @param projectId 项目id
  */
export function getMonitorParametersByProjectId(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/monitor-parameters`, {
        params: {
            ...params,
        }
    })
}

/**
  * 获得监测参数详情
  * 
  * @param id 监测参数id
  */
export function getMonitorParameterById(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/monitor-parameters/${id}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 删除根监测参数
 * 
 * @param id 监测参数id
 */
export function deleteMonitorParameterById(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/monitor-parameters/${id}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 编辑根监测参数
 * 
 * @param id   监测参数id
 * @param data 监测参数数据
 */
export function updateMonitorParameter(id: number, data: MonitorParameter, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/monitor-parameters/${id}`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 批量更新直接参数，使用场景是参数设备匹配、关联设备
 * 
 * @param projectId 项目id
 * @param dataList  直接参数列表
 */
export function multiUpdateMonitorParameterDqs(projectId: number, data: MonitorParameter[], params?: {}): Promise<StdResponse<any>> {
    return request.put(`/projects/${projectId}/monitor-parameter-dqs/multi`, data, {
        params: {
            ...params,
        }
    })
}

/**
* 更新直接参数-单个更新
* 
* @param id   直接参数id
* @param data 直接参数数据
*/
export function updateMonitorParameterDq(id: number, data: MonitorParameter, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/monitor-parameter-dqs/${id}`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 获得参数下一个序号
 */
export function getMonitorParameterNextSeq(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/monitor-parameters/next-seq`, {
        params: {
            ...params,
        }
    })
}

/**
 * 获得传感器相关的间接参数
 */
export function getMonitorParametersBySensorId(sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/sensors/${sensorId}/monitor-parameters`, {
        params: {
            ...params,
        }
    })
}

export function getMonitorParameterRelationsByProjectId(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/monitor-parameter-relations`, {
        params: {
            ...params,
        }
    })
}

export function updateMonitorParameterDqForRelation(projectId: number, id: number, data: MonitorParameter, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/projects/${projectId}/monitor-parameters/${id}/relation`, data, {
        params: {
            ...params,
        }
    })
}

export function updateExtParameter(id: number, data: MonitorParameterExt, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/monitor-parameters/${id}/ext`, data, {
        params: {
            ...params,
        }
    })
}